export default __webpack_public_path__ + "static/media/cow-3.eeaa709a.png";